import React from 'react'
import Link from 'gatsby-link'


const Työ  = () => (
    <div style={{
        margin: '0 auto',
        width: '80%',
        display: 'grid',
        gridTemplateColumns: '2fr 1fr',
        gridGap: '5%',
        textAlign: 'justify',
        fontSize: '1.1vw',
        lineHeight: '1.2'

    }} >
        <div className={'palvelu-text'} >
            <h2 style={{
                color: '#B4BB2D',
                marginLeft: '3%'

            }}> <span className={'quote'}>&ldquo;</span> Työnantajan ja työntekijan yhteinen etu</h2>

            <p>
                Työterveyshammashoito on on yleistynyt viime vuosien aikana. Siitä hyötyvät sekä työnantaja,
                 että työntekijä. Kun hammashoidosta tehdään kirjallinen sopi- mus, 
                 on se täysin verovähennyskelpoista yrityksille ja samalla veroton etu myös työntekijälle. 
                 Suun terveys on osa kokonaisvaltaista terveyttä. Tutkimukset osoit- tavat, että aktiivinen
                  hammashoito vähentää sairauspoissaoloja. 
                 Sopimus työpaik- kahammashoidosta on siis sekä työnantajan että työntekijän etu.
                </p>
            <p> Sopimus työterveyshammashoidosta voidaan tehdä siten, että siinä määritellään korvattavat palvelut ja korvauksen laajuus. Yritys voi itse päättää, korvaako se hammashoidon kokonaan vai osittain. Etu tulee olla käytössä koko henkilöstöllä, 
            mutta sitä voidaan rajoittaa työsuhteen pituuden mukaan.</p>
            <h4 style={{
                color: '#B4BB2D',
                marginLeft: '3%'

            }}>
                Ota yhteyttä, niin kerromme sinulle lisää!</h4>
           

        </div>
        <div className={'review'}>
            
            <img src={require('../assets/tree.png')} />

        </div>
    </div>
)

export default Työ



// WEBPACK FOOTER //
// ./src/pages/tyo.js